
import dayjs from "dayjs";
import { RefObject } from "react";
import { AGENT_API_PREFIX, AGENT_BASE_URLS } from "./const";

export const handleSelectConversation = (
  sid: string,
  sessionId:string,
  blockUserInput:boolean,
  isSendingMessage:boolean,
  isCreatingConversation:boolean,
  selectConversation: (sid:string) => void
//   isMobile?:boolean,
//   setMobileSidebarOpen?: Dispatch<SetStateAction<boolean>>,
) => {
  if (sid === sessionId) return;
  if (blockUserInput || isSendingMessage || isCreatingConversation) return;
  //   if (isMobile) setMobileSidebarOpen(false);
  selectConversation(sid);
};

export const ensureTrailingSlash = (url?: string) =>
  !url ? "" : url.endsWith("/") ? url : `${url}/`;


export const buildAgentUrl = (scope: string) => `${AGENT_BASE_URLS.SUPPORT}/${AGENT_API_PREFIX.SUPPORT}/${scope}/`;

const MERMAID_BLOCK_RE = /```\s*mermaid[\s\S]*?```/gi;

export const buildConversationPreview = (
  text: string | undefined,
  diagramLabel: string
): string => {
  if (!text) return "";
  const stripped = text
    .replace(MERMAID_BLOCK_RE, " ")
    .replace(/\s+/g, " ")
    .trim();
  const original = text.replace(/\s+/g, " ").trim();
  const hadMermaid = stripped !== original;
  if (!hadMermaid) return text.slice(0, 80);
  const tag = `📊 ${diagramLabel}`;
  return (stripped ? `${tag} — ${stripped}` : tag).slice(0, 80);
};


export const formatTimestampFromIso = (iso?: string) => {
  if (!iso) return undefined;
  const d = dayjs(iso);
  return d.isValid() ? d.format("HH:mm") : undefined;
};

export const readImageAsBase64 = (
  file: File
): Promise<{ base64: string; height: number; width: number }> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error("FileReader error"));
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.split(",")[1] ?? "";
      const img = new Image();
      img.onload = () => resolve({ base64, height: img.naturalHeight, width: img.naturalWidth });
      img.onerror = () => reject(new Error("Invalid image file"));
      img.src = dataUrl;
    };
    reader.readAsDataURL(file);
  });

export const scrollToLastMessage = (messagesContainerRef: RefObject<HTMLDivElement>) => {
  if (messagesContainerRef && messagesContainerRef.current) {
    setTimeout(() => {
        messagesContainerRef.current!.scrollTo({
          top: messagesContainerRef.current!.scrollHeight,
          behavior: "auto"
        });
    }, 300);
  }
};
